<template>
    <div class="fill-height grey lighten-4">
        <v-card class="d-flex flex-column fill-height" tile>
            <divider color="primary darken-1"/>

            <v-app-bar
                    dense
                    color="primary"
                    class="flex-grow-0 px-0"
            >
              <v-tabs
                  v-model="currentPage"
                  background-color="transparent"
                  color="secondary"
                  dark
                  style="max-width: 100%"
                  show-arrows
              >
                <v-tab v-show="user.adminOptions.users">Users</v-tab>
                <v-tab v-show="user.adminOptions.farms">Farms</v-tab>
                <v-tab v-show="user.adminOptions.varieties">Varieties</v-tab>
                <v-tab v-show="user.adminOptions.blocks">Blocks</v-tab>
                <v-tab v-show="user.adminOptions.employees">Employees</v-tab>
                <v-tab v-show="user.adminOptions.piecework">Piecework</v-tab>
                <v-tab v-show="user.adminOptions.devices">Devices</v-tab>
                <v-tab v-show="user.adminOptions.pinManagement">HR</v-tab>
                <v-tab v-show="user.adminOptions.contracts">Contracts</v-tab>
                <v-tab v-show="user.adminOptions.status">Employee Statuses</v-tab>
                <v-tab v-show="user.adminOptions.warnings">Warnings</v-tab>
                <v-tab v-show="user.adminOptions.shifts">Shifts</v-tab>
              </v-tabs>
            </v-app-bar>

            <divider color="primary darken-1"/>

            <v-tabs-items fill-height v-model="currentPage" class="of-y fill-height">

                <v-tab-item :value="0" v-if="user.adminOptions.users" class="fill-height"><users/></v-tab-item>
                <v-tab-item :value="1" v-if="user.adminOptions.farms" class="fill-height"><farms/></v-tab-item>
                <v-tab-item :value="2" v-if="user.adminOptions.varieties" class="fill-height"><varieties/></v-tab-item>
                <v-tab-item :value="3" v-if="user.adminOptions.blocks" class="fill-height"><blocks/></v-tab-item>
                <v-tab-item :value="4" v-if="user.adminOptions.employees" class="fill-height"><emp/></v-tab-item>
                <v-tab-item :value="5" v-if="user.adminOptions.piecework" class="fill-height"><piece/></v-tab-item>
                <v-tab-item :value="6" v-if="user.adminOptions.devices" class="fill-height"><devices/></v-tab-item>
                <v-tab-item :value="7" v-if="user.adminOptions.recruitment" class="fill-height"><h-r-pins/></v-tab-item>
                <v-tab-item :value="8" v-if="user.adminOptions.contracts" class="fill-height"><contracts/></v-tab-item>
                <v-tab-item :value="9" v-if="user.adminOptions.status" class="fill-height"><employee-statuses/></v-tab-item>
                <v-tab-item :value="10" v-if="user.adminOptions.warnings" class="fill-height"><warnings/></v-tab-item>
              <v-tab-item :value="11" v-if="user.adminOptions.shifts" class="fill-height"><setup-shifts/></v-tab-item>

            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Users from "./Users/Users";
import Farms from "./Farms/Farms";
import Varieties from "./Varieties/Varieties";
import Blocks from "./Blocks/Blocks";
import Emp from "./Emp/Emp";
import Piece from "./Piece Work/Piece";
import Divider from "../General/Divider";
import Devices from "./Devices/Devices";
import HRPins from "@/components/Setup/HR Pins/HRPins";
import Contracts from "@/components/Setup/Contracts/Contracts";
import EmployeeStatuses from "@/components/Setup/EmployeeStatus/EmployeeStatuses.vue";
import Warnings from "@/components/Setup/Warnings/Warnings.vue";
import SetupShifts from "@/components/Setup/Shifts/SetupShifts.vue";

export default {
    components: {
      SetupShifts,
      EmployeeStatuses, Contracts, HRPins, Devices, Divider, Piece, Emp, Blocks, Varieties, Farms, Users, Warnings},
    props: {},
    data() {
        return {
            currentPage: 0
        }
    },
    created() {
        if (!this.user.adminOptions.users)
            this.currentPage = 1;
    },
    watch: {},
    methods: {},
    computed: {
        ...mapGetters(['user'])
    },
}
</script>

<style scoped>

</style>